export default defineNuxtPlugin(() => {
  if (typeof window === 'undefined') return

  const w = window as any
  const d = document
  const queueName = 'uetq'
  const tagId = '343260521'

  // Evita carregar a UET duas vezes
  if (
    d.querySelector(`script[data-uet-tag="${tagId}"]`) ||
    d.querySelector(`script[src*="bat.bing.net/bat.js"]`)
  ) {
    return
  }

  w[queueName] = w[queueName] || []

  const options: any = {
    ti: tagId,
    enableAutoSpaTracking: true,
    ts: new Date().getTime(),
  }

  const script = d.createElement('script')

  script.src =
    `https://bat.bing.net/bat.js?ti=${encodeURIComponent(tagId)}`

  script.async = true
  script.dataset.uetTag = tagId

  script.onload = script.onreadystatechange = function (this: HTMLScriptElement) {
    const readyState = this.readyState

    if (
      readyState &&
      readyState !== 'loaded' &&
      readyState !== 'complete'
    ) {
      return
    }

    if (typeof w.UET !== 'function') {
      console.error('[Microsoft Ads] Biblioteca UET não foi carregada.')
      return
    }

    options.q = w[queueName]
    w[queueName] = new w.UET(options)
    w[queueName].push('pageLoad')

    script.onload = null
    script.onreadystatechange = null
  }

  const firstScript = d.getElementsByTagName('script')[0]

  if (firstScript?.parentNode) {
    firstScript.parentNode.insertBefore(script, firstScript)
  } else {
    d.head.appendChild(script)
  }
})
